"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMetricValue = formatMetricValue;
exports.getDeviceMetrics = getDeviceMetrics;
exports.getMetricDefinition = getMetricDefinition;
var device_metrics_1 = require("../constants/device-metrics");
function getDeviceMetrics(device) {
    // Once the device has reported, only the data points it actually sends are offered.
    if (device.dataPoints && Object.keys(device.dataPoints).length) {
        var sentKeys_1 = Object.keys(device.dataPoints);
        return Object.values(device_metrics_1.ALL_DEVICE_METRICS).filter(function (metric) { return sentKeys_1.includes(metric.key); });
    }
    if (device.deviceFamily === "DIGITALTWIN") {
        return device_metrics_1.DIGITAL_TWIN_METRICS;
    }
    return (device.deviceType && device_metrics_1.DEVICE_METRICS_BY_TYPE[device.deviceType]) || [];
}
function formatMetricValue(value, definition) {
    if (value === null || value === undefined) {
        return "—";
    }
    var number = value.toFixed(definition.digits);
    if (!definition.unit) {
        return number;
    }
    // Degree and percent signs sit against the number; other units get a space.
    return definition.unit === "°C" || definition.unit === "%" ? "".concat(number).concat(definition.unit) : "".concat(number, " ").concat(definition.unit);
}
function getMetricDefinition(key) {
    return device_metrics_1.ALL_DEVICE_METRICS[key];
}
